<template>
  <svg class="svg-animation-vi">
    <symbol id="svg_arrow-button-vi" viewBox="0 0 120 96" preserveAspectRatio="xMidYMid meet">
      <g transform="matrix(1,0,0,1,34.548004150390625,45.29199981689453)">
        <g opacity="1" transform="matrix(1,0,0,1,0,0)">
          <path
            stroke-linecap="butt"
            stroke-linejoin="miter"
            fill-opacity="0"
            stroke-miterlimit="10"
            id="NAcEkFgdYY2"
            stroke="currentColor"
            stroke-opacity="1"
            stroke-width="8"
            d="M72.80899810791016,3 C72.80899810791016,3 3,3 3,3"
            class="svg-vi-path1">
            <animate attributeName="d" dur=".3s" repeatCount="once" fill="freeze" restart="always"></animate>
          </path>
        </g>
      </g>
      <g transform="matrix(1,0,0,1,-11,-11.057998657226562)">
        <g opacity="1" transform="matrix(1,0,0,1,67,59.02899932861328)">
          <path
            stroke-linecap="round"
            stroke-linejoin="miter"
            fill-opacity="0"
            stroke-miterlimit="10"
            stroke="currentColor"
            stroke-opacity="1"
            stroke-width="8"
            d="M18.483999252319336,33.46200180053711 C18.986000061035156,33 19.489999771118164,32.52199935913086 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188"
            class="svg-vi-path2">
            <animate attributeName="d" dur=".5s" repeatCount="once" fill="freeze" restart="always"></animate>
          </path>
        </g>
      </g>
    </symbol>

    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg_arrow-button-vi"></use>
  </svg>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>
@keyframes svg-animate {
  0% {
    d: path(' M0 0');
  }

  38% {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 71,3 68,3');
  }

  60% {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 3,3 3,3');
  }

  to {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 3,3 3,3');
  }
}

@keyframes svg-animate2 {
  0% {
    d: path(' M0 0');
  }

  2.6% {
    d: path(' M3.76200008392334,-42.64699935913086 C2.6480000019073486,-42.933998107910156 1.5180000066757202,-43.176998138427734 0.3720000088214874,-43.375999450683594');
  }

  5.2% {
    d: path(
      ' M0.8019999861717224,-43.29899978637695 C-1.7999999523162842,-43.77899932861328 -4.482999801635742,-44.02899932861328 -7.223999977111816,-44.02899932861328 C-9.432000160217285,-44.02899932861328 -11.607999801635742,-43.86600112915039 -13.739999771118164,-43.553001403808594'
    );
  }

  7.8% {
    d: path(
      ' M-4.453000068664551,-43.94300079345703 C-5.36899995803833,-44 -6.293000221252441,-44.02899932861328 -7.223999977111816,-44.02899932861328 C-17.93600082397461,-44.02899932861328 -27.902999877929688,-40.20199966430664 -35.70100021362305,-33.84000015258789'
    );
  }

  10.4% {
    d: path('M-12.060999870300293,-43.766998291015625 C-32.17499923706055,-41.582000732421875 -48.724998474121094,-25.952999114990234 -51.56800079345703,-6.0920000076293945');
  }

  13% {
    d: path(
      ' M-21.638999938964844,-41.643001556396484 C-39.11000061035156,-35.698001861572266 -52,-19.305999755859375 -52,-0.014999999664723873 C-52,10.817000389099121 -48.09000015258789,20.740999221801758 -41.604000091552734,28.415000915527344'
    );
  }

  15.6% {
    d: path(
      ' M-32.21099853515625,-36.42100143432617 C-44.066001892089844,-28.5 -52,-15.14900016784668 -52,-0.014999999664723873 C-52,23.719999313354492 -33.22700119018555,43.09400177001953 -9.71399974822998,43.99599838256836'
    );
  }

  18.2% {
    d: path(
      'M-42.03900146484375,-27.533000946044922 C-48.24399948120117,-19.996000289916992 -52,-10.428000450134277 -52,-0.014999999664723873 C-52,24.29400062561035 -32.30799865722656,44.02899932861328 -8,44.02899932861328 C4.394999980926514,44.02899932861328 11.437000274658203,40.229000091552734 19.63800048828125,32.37699890136719'
    );
  }

  20.8% {
    d: path(
      'M-49.16899871826172,-15.322999954223633 C-50.99599838256836,-10.555999755859375 -52,-5.3979997634887695 -52,-0.014999999664723873 C-52,24.29400062561035 -32.30799865722656,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C26.735000610351562,25.29400062561035 33.46900177001953,18.61199951171875 39.01100158691406,13.130000114440918'
    );
  }

  23.4% {
    d: path(
      'M-51.981998443603516,-1.2519999742507935 C-51.99399948120117,-0.8410000205039978 -52,-0.42899999022483826 -52,-0.014999999664723873 C-52,24.29400062561035 -32.30799865722656,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 51.095001220703125,-0.5490000247955322 49.505001068115234,-2.0850000381469727'
    );
  }

  26% {
    d: path(
      ' M-50.15800094604492,12.633000373840332 C-44.72800064086914,30.785999298095703 -27.913000106811523,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 45.95000076293945,-5.494999885559082 37.638999938964844,-13.621000289916992'
    );
  }

  28.6% {
    d: path(
      ' M-44.500999450683594,24.58300018310547 C-36.59700012207031,36.31100082397461 -23.201000213623047,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 41.47800064086914,-9.793999671936035 29.124000549316406,-21.98200035095215'
    );
  }

  31.2% {
    d: path(
      ' M-36.39899826049805,33.625 C-28.736000061035156,40.1150016784668 -18.826000213623047,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 38.0890007019043,-13.052000045776367 23.476999282836914,-27.572999954223633'
    );
  }

  33.8% {
    d: path(
      ' M-27.253999710083008,39.597999572753906 C-21.43899917602539,42.43600082397461 -14.906000137329102,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 36.03300094604492,-15.029000282287598 20.341999053955078,-30.69499969482422'
    );
  }

  36.4% {
    d: path(
      ' M-18.14299964904785,42.85300064086914 C-14.88700008392334,43.62200164794922 -11.491000175476074,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  39% {
    d: path(
      ' M-9.795999526977539,43.99300003051758 C-9.199999809265137,44.016998291015625 -8.60099983215332,44.02899932861328 -8,44.02899932861328 C4.577000141143799,44.02899932861328 11.642000198364258,40.117000579833984 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  41.6% {
    d: path(
      ' M-2.5420000553131104,43.74800109863281 C6.789999961853027,42.72100067138672 12.932999610900879,38.86800003051758 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  44.2% {
    d: path(
      ' M3.4549999237060547,42.584999084472656 C9.67199993133545,40.78499984741211 14.562000274658203,37.29100036621094 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  46.8% {
    d: path(
      ' M8.194999694824219,40.7760009765625 C12.32800006866455,38.78900146484375 16.017000198364258,35.882999420166016 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  49.4% {
    d: path(
      ' M11.788000106811523,38.75600051879883 C14.550000190734863,36.974998474121094 17.202999114990234,34.736000061035156 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  53% {
    d: path(
      ' M14.420999526977539,36.900001525878906 C16.267000198364258,35.4900016784668 18.100000381469727,33.86800003051758 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  55.6% {
    d: path(
      ' M16.315000534057617,35.37799835205078 C17.52899932861328,34.354000091552734 18.75,33.237998962402344 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  58.2% {
    d: path(
      ' M18.26300048828125,33.665000915527344 C18.836999893188477,33.13999938964844 19.415000915527344,32.595001220703125 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  60.8% {
    d: path(
      ' M18.483999252319336,33.46200180053711 C18.986000061035156,33 19.489999771118164,32.52199935913086 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  63.4% {
    d: path(
      ' M18.483999252319336,33.46200180053711 C18.986000061035156,33 19.489999771118164,32.52199935913086 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  to {
    d: path(
      ' M18.483999252319336,33.46200180053711 C18.986000061035156,33 19.489999771118164,32.52199935913086 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }
}

@keyframes svg-animate-out-1 {
  0% {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 3,3 3,3');
  }

  38% {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 13.89900016784668,3 4.311999797821045,3');
  }

  60% {
    d: path(' M72.80899810791016,3 C72.80899810791016,3 67.7979965209961,3 60.459999084472656,3');
  }

  to {
    d: path('M0 0');
  }
}

@keyframes svg-animate-out-2 {
  0% {
    d: path(
      ' M18.483999252319336,33.46200180053711 C18.986000061035156,33 19.489999771118164,32.52199935913086 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  7% {
    d: path(
      ' M18.884000778198242,33.09000015258789 C19.253999710083008,32.744998931884766 19.625999450683594,32.39099884033203 20,32.02899932861328 C36,16.02899932861328 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  14% {
    d: path(
      ' M21.44099998474121,30.589000701904297 C36.946998596191406,15.100000381469727 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  21% {
    d: path(
      ' M25.211000442504883,26.827999114990234 C39.29800033569336,12.791000366210938 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  28% {
    d: path(
      ' M31.93000030517578,20.145999908447266 C43.09600067138672,9.062999725341797 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  35% {
    d: path(
      ' M43.65299987792969,8.543000221252441 C48.722999572753906,3.5380001068115234 52,0.32100000977516174 52,0.32100000977516174 C52,0.32100000977516174 35.356998443603516,-15.678999900817871 19.35700035095215,-31.679000854492188'
    );
  }

  42% {
    d: path(' M44.60100173950195,-6.835999965667725 C38.262001037597656,-12.993000030517578 28.700000762939453,-22.336000442504883 19.35700035095215,-31.679000854492188');
  }

  49% {
    d: path(' M32.801998138427734,-18.361000061035156 C28.53499984741211,-22.55299949645996 23.920000076293945,-27.115999221801758 19.35700035095215,-31.679000854492188');
  }

  56% {
    d: path(' M26.05500030517578,-25.014999389648438 C23.840999603271484,-27.207000732421875 21.593000411987305,-29.44300079345703 19.35700035095215,-31.679000854492188');
  }

  63% {
    d: path(' M21.09600067138672,-29.941999435424805 C20.516000747680664,-30.520999908447266 19.93600082397461,-31.100000381469727 19.35700035095215,-31.679000854492188');
  }

  70% {
    d: path(' M19.743000030517578,-31.292999267578125 C19.61400032043457,-31.422000885009766 19.486000061035156,-31.549999237060547 19.35700035095215,-31.679000854492188');
  }

  to {
    d: path('M0 0');
  }
}

.svg-animation-vi {
  --svg-animate-name: svg-animate-out-1;
  --svg-animate-name2: svg-animate-out-2;
  --svg-animate-duration: 0.3s;
  --svg-animate-delay: 0s;
  display: inline-flex;
  height: 24px;
  min-width: 24px;
  width: 24px;
  color: #fff;
  opacity: 0;
}

#svg_arrow-button-vi .svg-vi-path1 {
  animation: var(--svg-animate-name) var(--svg-animate-duration) ease forwards;
  animation-delay: var(--svg-animate-delay);
}

#svg_arrow-button-vi .svg-vi-path2 {
  animation: var(--svg-animate-name2) var(--svg-animate-duration) ease forwards;
  animation-delay: var(--svg-animate-delay);
}

@supports (d: path('M0 0')) {
  .svg-animation-vi {
    transition: opacity 0s ease;
    transition-delay: 0.3s;
  }
}

*[svg-arrow]:hover .svg-animation-vi {
  --svg-animate-delay: 0.3s;
  --svg-animate-name: svg-animate;
  --svg-animate-name2: svg-animate2;
  --svg-animate-duration: 1s;
  display: inline-flex;
  opacity: 1;
}
</style>
